// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IBE Styles */
:root {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

html body .ibe-body {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

/* price details table */
html body .placemakr-ibe table.price-details {
  width: 100%;
  font-size: 0.75rem;
  line-height: 1rem;
}
@media (min-width: 768px) {
  html body .placemakr-ibe table.price-details {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

html body .placemakr-ibe table.price-details th, html body .placemakr-ibe td {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

html body .placemakr-ibe table.price-details td.price {
  text-align: right;
}

html body .placemakr-ibe *:focus-visible {
  outline: 1px solid #122634 !important;
  outline-offset: 2px;
}

html body .placemakr-ibe .search-input:focus, html body .placemakr-ibe .search-input:focus-visible, html body .placemakr-ibe .breadcrumbs .link:focus-visible {
  border-bottom: 1px solid #122634 !important;
  outline: none !important;
  border-radius: 0 !important;
}

html body .placemakr-ibe .adyen-checkout__dropin input:focus-visible, html body .placemakr-ibe .adyen-checkout__dropin select:focus-visible, html body .placemakr-ibe .adyen-checkout__input:focus-visible {
  outline: none !important;
}

html body .placemakr-ibe .adyen-checkout__input {
  border: none !important;
}

@keyframes buttonPulse {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

html body .placemakr-ibe .btn-pulse {
  animation: buttonPulse 1s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/ibe.css"],"names":[],"mappings":"AAAA,eAAe;AAEb;EAAA,kBAAe;EAAf;AAAe;;AAIf;EAAA,kBAAe;EAAf;AAAe;;AAGjB,wBAAwB;AAEtB;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;AAAhC;EAAA;IAAA,mBAAgC;IAAhC;EAAgC;AAAA;;AAKhC;EAAA,qBAAkB;EAAlB,sBAAkB;EAAlB,qBAAkB;EAAlB;AAAkB;;AAIlB;EAAA;AAAiB;;AAGnB;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EAGE,2CAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EAGE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* IBE Styles */\n:root {\n  @apply bg-white;\n}\n\nbody {\n  @apply bg-white;\n}\n\n/* price details table */\ntable.price-details {\n  @apply text-xs md:text-sm w-full;\n}\n\ntable.price-details th,\ntd {\n  @apply px-1 py-0.5;\n}\n\ntable.price-details td.price {\n  @apply text-right;\n}\n\n*:focus-visible {\n  outline: 1px solid #122634 !important;\n  outline-offset: 2px;\n}\n\n.search-input:focus,\n.search-input:focus-visible,\n.breadcrumbs .link:focus-visible {\n  border-bottom: 1px solid #122634 !important;\n  outline: none !important;\n  border-radius: 0 !important;\n}\n\n.adyen-checkout__dropin input:focus-visible,\n.adyen-checkout__dropin select:focus-visible,\n.adyen-checkout__input:focus-visible {\n  outline: none !important;\n}\n\n.adyen-checkout__input {\n  border: none !important;\n}\n\n@keyframes buttonPulse {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(1.25);\n  }\n  50% {\n    transform: scale(1);\n  }\n  75% {\n    transform: scale(1.25);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.btn-pulse {\n  animation: buttonPulse 1s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
